import * as React from 'react';
import Axios from "axios";
import Swal from 'sweetalert2';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Layout from '../Layout/Layout';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

async function getData(id) {
  try {
    let result = await Axios.get(`${process.env.REACT_APP_BACKEND_DOMAIN_API}/cms_user/info/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem('accessToken')
        }
      });
    return result.data;
  } catch (error) {
    console.log(`bigc-online-catalogs: ${error}`);
  }
}


async function updateUser(credentials) {
  try {
    let payload = JSON.stringify(credentials);

    let result = await Axios.post(process.env.REACT_APP_BACKEND_DOMAIN_API + '/cms_user/update',
      payload, {
      headers: {
        'Content-Type': 'application/json',
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        "x-access-token": sessionStorage.getItem('accessToken')
      }
    });
    return result.data;
  } catch (error) {
    return { message: "update failed" };
  }
}

export default function Profile() {

  const userId = sessionStorage.getItem('userId');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [status, setStatus] = React.useState('active');
  const [isError, setIsError] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);

  React.useEffect(async () => {
    if (userId) {
      const getUser = await getData(userId);
      setFirstName(getUser.first_name);
      setLastName(getUser.last_name);
      setEmail(getUser.email);
      setStatus(getUser.status);
      //setPassword(getUser.password);
    }
  }, [userId]);

  const handleChange = (event, setTarget) => {
    event.preventDefault();
    const value = event.target.value;

    switch (setTarget) {
      case 'first_name': setFirstName(value); break;
      case 'last_name': setLastName(value); break;
      case 'email': setEmail(value); break;
      case 'password': setPassword(value); break;
      case 'status': setStatus(value); break;
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsError(true);
    //const myFile = formRef.current;
    if ((!firstName) || (!lastName) || (!email)) {
      Swal.fire({
        icon: 'error',
        title: 'Input Failed',
      });
    } else {
      setIsError(true);
      setSubmitted(true);
      let response,jsonData;
      if (userId) {
        if(password){
          jsonData = {
            id: userId,
            first_name: firstName,
            last_name: lastName,
            email: email,
            password: password,
            status: status
          };
        }else{
          jsonData = {
            id: userId,
            first_name: firstName,
            last_name: lastName,
            email: email,
            status: status
          };    
        }
        response = await updateUser(jsonData);
        if (response == 'success') {
          Swal.fire({
            icon: 'success',
            title: 'Success',
          }).then(() => {
            setSubmitted(false);
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed',
          }).then(() => {
            setSubmitted(false);
          });
        }
      }
      else {
        Swal.fire({
          icon: 'error',
          title: 'UserId Failed',
        });
      }
    }
  }

  return (
    <Layout>
      <Paper sx={{ height: 650, width: '100%' }}>
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          sx={{ minHeight: '100vh', p: 5 }}
        >
          <Box
            component="form"
            sx={{
              '& .MuiTextField-root': { mb: 5, width: 500 },
            }}
            noValidate
            autoComplete="off"
            onSubmit={e => handleSubmit(e)}
          >
            <h2>User Info</h2>
            <TextField
              required
              fullWidth
              id="first_name"
              label="First Name"
              value={firstName}
              error={!firstName && isError}
              //focused={dataRichId}
              onChange={e => handleChange(e, 'first_name')}
            />
            <br />
            <TextField
              required
              fullWidth
              id="last_name"
              label="Last Name"
              value={lastName}
              error={!lastName && isError}
              //focused={dataRichId}
              onChange={e => handleChange(e, 'last_name')}
            />
            <br />
            <TextField
              disabled
              fullWidth
              id="email"
              label="Email"
              value={email}
            />
            <br />
            <TextField
              fullWidth
              type="password"
              id="password"
              label="Password"
              value={password}
              onChange={e => handleChange(e, 'password')}
            />
            <br />
            <TextField
              select
              required
              fullWidth
              id="status"
              name="status"
              label="Status"
              value={status}
              error={!status && isError}
              //focused={dataStatus}
              onChange={e => handleChange(e, 'status')}
            >
              <MenuItem value='active'>Active</MenuItem>
              <MenuItem value='inactive'>Inactive</MenuItem>
            </TextField>
            <br />
            <Button
              color="primary"
              variant="contained"
              type="submit"
              disabled={submitted}
            >
              {
                (submitted && 'Process')
                || (!submitted && 'Save')
              }
            </Button>
          </Box>

        </Grid>

      </Paper>
    </Layout>
  );
}

